


































import {Vue, Component} from 'vue-property-decorator'

import BaseModal from '../common/BaseModal.vue'

import {bankList} from './constants/bankList'

@Component({
  components: {
    BaseModal,
  }
})

export default class BankModal extends Vue {
  bankList = bankList

}
